import { createFileRoute } from "@tanstack/react-router";

import { ProjectCarousel } from "@/components/project-carousel";
import { SiteFooter } from "@/components/site-footer";
import { HomeNav } from "@/components/home-nav";
import { clipping, clippingImages, clippingSections } from "@/data/clipping";
import clipVideo from "@/assets/hifa_cybe_video.mp4.asset.json";


export const Route = createFileRoute("/clipping")({
  head: () => ({
    meta: [
      { property: "og:url", content: "https://www.luizajesusdoprado.com/clipping" },
      { title: "Clipping — Press & Media | Luiza Jesus do Prado" },
      {
        name: "description",
        content:
          "Press, television, academic research and institutional records about the work of Luiza Jesus do Prado.",
      },
      { property: "og:title", content: "Clipping — Press & Media | Luiza Jesus do Prado" },
      {
        property: "og:description",
        content:
          "Selected press, TV appearances, academic papers and institutional archives on Luiza Jesus do Prado.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:image", content: clippingImages[0] ?? "" },
      { name: "twitter:image", content: clippingImages[0] ?? "" },
    ],
  }),
  component: Clipping,
});

function Clipping() {
  return (
    <div className="min-h-screen bg-ink text-bone">
      <HomeNav />

      <main id="main-content" className="px-4 pb-24 pt-32 md:px-[6vw] md:pt-40">
        <section className="relative overflow-hidden">
          <h1 className="font-display text-[clamp(1.8rem,4vw,3.2rem)] font-light leading-[1] text-bone">
            Clipping
          </h1>
        </section>

        <section className="mt-10">
          <video
            src={clipVideo.url}
            controls
            playsInline
            preload="metadata"
            className="mx-auto block w-full max-w-4xl bg-black"
          />
        </section>

        <div className="mt-16 md:mt-24">
          {clippingSections.map((section, sectionIndex) => {
            const items = clipping.filter((item) => item.kind === section);
            return (
              <section
                key={section}
                className="grid grid-cols-1 gap-4 border-t border-bone/15 py-8 md:grid-cols-12 md:gap-6 md:py-10"
              >
                <div className="md:col-span-4">
                  <p className="font-sans text-[10px] font-light uppercase tracking-[0.2em] text-bone/65">
                    ({String(sectionIndex + 1).padStart(2, "0")})
                  </p>
                  <h2 className="mt-2 font-display text-[clamp(1.05rem,1.8vw,1.5rem)] font-light leading-[1.05] text-bone">
                    {section}
                  </h2>
                </div>

                <ul className="md:col-span-8">
                  {items.map((item) => (
                    <li
                      key={item.url}
                      className="grid grid-cols-[3.5rem_minmax(0,1fr)] gap-4 border-b border-bone/10 py-3 last:border-b-0"
                    >
                      <span className="shrink-0 font-sans text-[11px] font-light tracking-[0.12em] text-bone/65">
                        ↗
                      </span>
                      <a
                        href={item.url}
                        target="_blank"
                        rel="noreferrer"
                        className="min-w-0 font-sans text-[12px] font-light leading-[1.55] text-bone/85 transition-opacity hover:opacity-60 md:text-[13px]"
                      >
                        {item.title}
                        <span className="text-bone/65"> — {item.outlet}</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </section>
            );
          })}
        </div>


        <section className="mt-8 border-t border-bone/15 pt-8">
          <ProjectCarousel
            images={clippingImages.map((src, index) => ({
              src,
              alt: `Press documentation ${index + 1}`,
            }))}
          />
        </section>




      </main>

      <SiteFooter />
    </div>
  );
}
